export default [
  {
    name: "Animal Shelter ",
    socrataName: "Animal Shelter ",
    icon: "fal fa-paw",
  },
  {
    name: "Arts & Culture ",
    socrataName: "Arts & Culture, Office of",
    icon: "fal fa-palette",
  },
  {
    name: "Auditor",
    socrataName: "City Auditor%27s Office",
    icon: "fal fa-calculator",
  },
  {
    name: "Budget Office ",
    socrataName: "City Budget Office",
    icon: "fal fa-clipboard-list",
  },
  {
    name: "City Clerk ",
    socrataName: "City Clerk ",
    icon: "fal fa-copy",
  },
  {
    name: "City Light ",
    socrataName: "Seattle City Light",
    icon: "fal fa-lightbulb",
  },
  {
    name: "Civil Rights ",
    socrataName: "Office for Civil Rights",
    icon: "fal fa-fist-raised",
  },
  {
    name: "Community Police Commission",
    socrataName: "Community Police Commission",
    icon: "fal fa-shield-check",
  },
  {
    name: "Construction and Inspections ",
    socrataName: "Construction & Inspections, Seattle Department of",
    icon: "fal fa-tools",
  },
  {
    name: "Customer Service Bureau ",
    socrataName: "Customer Service Bureau ",
    icon: "fal fa-user-headset",
  },
  {
    name: "Economic Development ",
    socrataName: "Office of Economic Development",
    icon: "fal fa-chart-line",
  },
  {
    name: "Education and Early Learning ",
    socrataName: "Education %26 Early Learning, Department of",
    icon: "fal fa-child",
  },
  {
    name: "Emergency Management ",
    socrataName: "Office of Emergency Management",
    icon: "fal fa-exclamation-triangle",
  },
  {
    name: "Ethics and Elections Commission ",
    socrataName: "Ethics %26 Elections Commission",
    icon: "fal fa-ballot-check",
  },
  {
    name: "Film and Music ",
    socrataName: "Film and Music ",
    icon: "fal fa-film",
  },
  {
    name: "Finance and Administrative Services ",
    socrataName: "Finance & Admin Services",
    icon: "fal fa-usd-circle",
  },
  {
    name: "Fire Department ",
    socrataName: "Fire Department",
    icon: "fal fa-fire-extinguisher",
  },
  {
    name: "Hearing Examiner ",
    socrataName: "Hearing Examiner, Office of",
    icon: "fal fa-podium",
  },
  {
    name: "Housing ",
    socrataName: "Office of Housing",
    icon: "fal fa-home-lg-alt",
  },
  {
    name: "Human Resources ",
    socrataName: "Seattle Dept of Human Resource %28SDHR%29",
    icon: "fal fa-users-cog",
  },
  {
    name: "Human Services ",
    socrataName: "Human Services Department",
    icon: "fal fa-hand-holding-heart",
  },
  {
    name: "Immigrant and Refugee Affairs ",
    socrataName: "Immigrant & Refugee Affairs, Office of",
    icon: "fal fa-passport",
  },
  {
    name: "Information Technology ",
    socrataName: "Information Technology",
    icon: "fal fa-desktop",
  },
  {
    name: "Inspector General ",
    socrataName: "Office of Inspector General",
    icon: "fal fa-clipboard-check",
  },
  {
    name: "Intergovernmental Relations ",
    socrataName: "Intergovernment Relations, Office of",
    icon: "fal fa-landmark",
  },
  {
    name: "Labor Standards ",
    socrataName: "Office of Labor Standards",
    icon: "fal fa-user-hard-hat",
  },
  {
    name: "Library ",
    socrataName: "Seattle Public Library",
    icon: "fal fa-book",
  },
  {
    name: "Municipal Archives, City Clerk ",
    socrataName: "Municipal Archives, City Clerk ",
    icon: "fal fa-archive",
  },
  {
    name: "Municipal Court ",
    socrataName: "Municipal Court",
    icon: "fal fa-gavel",
  },
  {
    name: "Neighborhoods ",
    socrataName: "Neighborhoods, Department of",
    icon: "fal fa-door-open",
  },
  {
    name: "Office of the Ombud ",
    socrataName: "Office of Employee Ombud",
    icon: "fal fa-comments",
  },
  {
    name: "Parks and Recreation ",
    socrataName: "Parks & Recreation, Seattle",
    icon: "fal fa-tree",
  },
  {
    name: "Planning and Community Development ",
    socrataName: "Planning & Community Development, Office of",
    icon: "fal fa-building",
  },
  {
    name: "Police ",
    socrataName: "Seattle Police Department",
    icon: "fal fa-shield",
  },
  {
    name: "Office of Police Accountability ",
    socrataName: "Office of Police Accountability ",
    icon: "fal fa-shield-check",
  },
  {
    name: "Public Utilities ",
    socrataName: "Seattle Public Utilities",
    icon: "fal fa-trash",
  },
  {
    name: "Retirement ",
    socrataName: "Employees%27 Retirement System",
    icon: "fal fa-piggy-bank",
  },
  {
    name: "Seattle Channel ",
    socrataName: "Seattle Channel ",
    icon: "fal fa-video",
  },
  {
    name: "Special Events ",
    socrataName: "Special Events ",
    icon: "fal fa-calendar-star",
  },
  {
    name: "Sustainability and Environment ",
    socrataName: "Office of Sustainability and Environment",
    icon: "fal fa-leaf",
  },
  {
    name: "Transportation ",
    socrataName: "Seattle Dept of Transportation",
    icon: "fal fa-car-bus",
  },
  {
    name: "Waterfront and Civic Projects ",
    socrataName: "Waterfront and Civic Projects ",
    icon: "fal fa-store-alt",
  },
];

